import { Component, OnInit } from '@angular/core';
import { GridButton } from 'src/app/core/models/grid-button.model';
import { GridColumn } from 'src/app/core/models/grid-column.model';
import moment from 'moment';
import { GridFilter } from 'src/app/core/models/grid-filter.model';
import { GridSearchFilter } from 'src/app/core/models/grid-search-filter.model';

@Component({
    selector: 'app-workshop-defects',
    templateUrl: './workshop-defects.component.html',
    styleUrls: ['./workshop-defects.component.scss'],
    standalone: false
})
export class WorkshopDefectsComponent implements OnInit {

  buttons: GridButton[] = [
    {label: 'Edit', link: '/workshop/defects/edit/:id', type: 'btn-warning'} as GridButton,
  ]

  columns: GridColumn[] = [
    {active: true, label: '#', field: 'id'} as GridColumn,
    {active: true, label: 'Vehicle', field: 'vehicle.registration'} as GridColumn,
    {active: true, label: 'Description', field: 'description'} as GridColumn,
    {active: true, label: 'Severity', field: 'severity.notes'} as GridColumn,
    {active: true, label: 'Source', field: 'source', value: v => v === 'walkaround' ? 'Driver Check' : 'Manual'} as GridColumn,
    {active: true, label: 'Status', field: 'status', value: v => ({open: 'Open', assigned: 'Assigned', in_progress: 'In Progress', complete: 'Complete'} as any)[v] || v} as GridColumn,
    {active: true, label: 'Fitters', field: 'fitterAssignments', value: (v) => v && v.length ? v.map(a => a.fitter.firstName + ' ' + a.fitter.lastName).join(', ') : 'Unassigned'} as GridColumn,
    {active: true, label: 'Raised', field: 'createdAt', value: v => moment(v).format('DD/MM/YYYY HH:mm')} as GridColumn,
  ];

  filters: GridFilter[] = []

  searchFields: any = ['description', 'vehicle.registration'];

  searchFilters: GridSearchFilter[] = [
    {
      field: 'vehicle.registration',
      label: 'Registration',
    } as GridSearchFilter,
    {
      field: 'status',
      label: 'Status',
    } as GridSearchFilter,
  ]

  constructor() { }

  ngOnInit(): void {
  }
}
